import type { AnchorDescriptor, Thread } from "../types/collaborateThread";

/** Build an anchor descriptor for jump-to-text from thread metadata. */
export function resolveThreadAnchor(thread: Thread): AnchorDescriptor | null {
  const quote = thread.quote?.trim() ?? "";
  const anchor = thread.anchor;

  if (anchor) {
    return {
      ...anchor,
      quoteText: anchor.quoteText?.trim() || quote || undefined,
    };
  }

  if (!quote) {
    return null;
  }

  return {
    type: "bookmark",
    id: "",
    versionId: "",
    quoteText: quote,
  };
}

export function threadHasDocumentLocation(thread: Thread): boolean {
  return resolveThreadAnchor(thread) !== null;
}
